import request from '@/utilities/request'

// 通知列表

export function noticeList(params) {
    return request({
        url: 'system/notice_list',
        method: 'get',
        params
    })
}

// 教师管理班级列表
export function classList(params) {
    return request({
        url: 'system/teacher_list',
        method: 'get',
        params
    })
}

// 教师接收通知
export function teacher_notice(params) {
    return request({
        url: 'system/received',
        method: 'get',
        params
    })
}


// 教师提交通知
export function noticePost(params) {
    return request({
        url: 'system/noticeadd',
        method: 'post',
        params
    })
}

//点击班级获取班级成员
export function studentList(params) {
    return request({
        url: 'system/classfriend',
        method: 'get',
        params
    })
}

//考勤管理
export function kaoQin(params) {
    return request({
        url: 'system/attendance_out',
        method: 'get',
        params
    })
}

//请假通知
export function qinJia(params) {
    return request({
        url: 'system/leave_list',
        method: 'get',
        params
    })
}

//体测
export function sports(params) {
    return request({
        url: 'system/measure_list',
        method: 'get',
        params
    })
}
//添加请假事件
export function qjPost(params) {
    return request({
        url: 'system/leave_add',
        method: 'post',
        params
    })
}

//添加智能体测
export function intelligence(params) {
    return request({
        url: 'system/intelligence_add',
        method: 'post',
        params
    })
}

//添加课表
export function week_add(params) {
    return request({
        url: 'system/timetable_add',
        method: 'post',
        params
    })
}

//编辑课程
export function week_edit(data) {
    return request({
        url:"system/timetable_edit",
        method:'post',
        data
    })
}

//删除课程
export function week_del(id){
    return request({
        url:'system/time_delete',
        method:'get',
        params:{id:id}
    })
}

//获取课程表
export function get_week(params) {
    return request({
        url: 'system/timetable_get',
        method: 'get',
        params
    })
}

//获取日期
export function get_time(params) {
    return request({
        url: 'system/get_week',
        method: 'get',
        params
    })
}

//比赛列表
export function match_list(params) {
    return request({
        url: 'match',
        method: 'get',
        params
    })
}
//添加赛事
export function match_add(params) {
    return request({
        url: 'match',
        method: 'post',
        params
    })
}
//个人比赛排名
export function match_ranking(params) {
    return request({
        url: 'match/rank/person',
        method: 'get',
        params
    })
}

//班级比赛排名
export function match_class(params) {
    return request({
        url: 'match/rank/class',
        method: 'get',
        params
    })
}

//获取学校排名
export function match_grade(params) {
    return request({
        url: 'match/rankGradeSchool',
        method: 'get',
        params
    })
}
//获取比赛参加列表
export function rank_list(params) {
    return request({
        url: 'match/rank_list',
        method: 'get',
        params
    })
}

//参加年级比赛
export function grade_list(params) {
    return request({
        url: 'match/grade_list',
        method: 'get',
        params
    })
}






